import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
  selector: 'app-footer',
  imports: [RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  private readonly analytics = inject(AnalyticsService);
  currentYear = new Date().getFullYear();

  onDemoCta(): void {
    this.analytics.trackCtaClick('footer-book-demo');
  }
}
